module.exports = __webpack_public_path__ + "media/images/placeholders/video-player-d565298bbd4fd6feb9fb48b6ab993176.svg";